"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.84.57H3.16c-.8 0-1.44.65-1.44 1.44v4.63c0 .52.28.99.74 1.24l5.31 2.84c.07.04.14.05.22.05l-.78 1.59-1.8.26 1.3 1.27-.31 1.79 1.61-.84 1.61.84-.31-1.79 1.3-1.27-1.8-.26-.78-1.59c.07 0 .15-.02.22-.05l5.31-2.84c.46-.25.74-.72.74-1.24V2.01c0-.79-.65-1.44-1.44-1.44h-.02ZM5.52 8.39 2.92 7a.408.408 0 0 1-.21-.36V3.93h2.81v4.46Zm3.96.53L8 9.71l-1.48-.79V3.93h2.96v4.99Zm3.81-2.28c0 .15-.08.29-.21.36l-2.6 1.39V3.93h1.96v-1H2.71v-.92c0-.24.2-.44.44-.44h9.69c.24 0 .44.2.44.44v4.63h.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.98.69h14.587l.008.007c1.088 0 1.98.885 1.98 1.98v6.968c0 .712-.39 1.357-1.02 1.695l-7.995 4.267a.547.547 0 0 1-.525 0L4.02 11.34A1.908 1.908 0 0 1 3 9.645V2.67C3 1.582 3.885.69 4.98.69Zm-.428 9.66 4.186 2.235h.007V5.377H4.133v4.268a.8.8 0 0 0 .42.705Zm7.726 4.125 2.415-1.29V5.377h-4.83v7.808l2.415 1.29Zm7.732-4.125a.814.814 0 0 0 .42-.705V2.677a.855.855 0 0 0-.855-.855H4.988a.855.855 0 0 0-.856.855v1.575h14.836v1.125h-3.143v7.208l4.185-2.235Zm-7.733 5.452 1.208 2.453 2.7.39-1.958 1.905.465 2.692-2.415-1.267-2.422 1.267.465-2.692-1.958-1.905 2.7-.39 1.215-2.453Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.64.92h19.45l.01.01c1.45 0 2.64 1.18 2.64 2.64v9.29c0 .95-.52 1.81-1.36 2.26l-10.66 5.69a.73.73 0 0 1-.7 0L5.36 15.12A2.544 2.544 0 0 1 4 12.86v-9.3C4 2.11 5.18.92 6.64.92ZM6.07 13.8l5.58 2.98h.01V7.17H5.51v5.69c0 .39.21.75.56.94Zm10.3 5.5 3.22-1.72V7.17h-6.44v10.41l3.22 1.72Zm10.31-5.5c.34-.19.56-.55.56-.94V3.57c0-.63-.51-1.14-1.14-1.14H6.65c-.63 0-1.14.51-1.14 1.14v2.1h19.78v1.5H21.1v9.61l5.58-2.98Zm-10.31 7.27 1.61 3.27 3.6.52-2.61 2.54.62 3.59-3.22-1.69-3.23 1.69.62-3.59-2.61-2.54 3.6-.52 1.62-3.27Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.18 1.567h29.64c2.1 0 3.817 1.71 3.817 3.818v14.167c0 1.365-.75 2.618-1.957 3.263l-16.238 8.67a.924.924 0 0 1-.885 0L7.32 22.815a3.687 3.687 0 0 1-1.958-3.263V5.385c0-2.1 1.71-3.818 3.818-3.818Zm7.822 24.296V10.68H7.23v8.872c0 .675.375 1.298.967 1.613l8.805 4.698ZM24 29.603l5.107-2.73.008-.008V10.68H18.892v16.192L24 29.602Zm15.787-8.438c.6-.323.968-.938.968-1.613h-.008V5.385c0-1.073-.87-1.943-1.942-1.943H9.172c-1.072 0-1.942.87-1.942 1.943v3.42h30.337v1.875h-6.592v15.187l8.812-4.702ZM24 31.71l2.452 4.98 5.498.795-3.975 3.87.937 5.475L24 44.243l-4.913 2.587.938-5.475-3.975-3.87 5.497-.795L24 31.71Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.24 2.09h39.52c2.8 0 5.09 2.28 5.09 5.09v18.89c0 1.82-1 3.49-2.61 4.35L32.59 41.98a1.232 1.232 0 0 1-1.18 0L9.76 30.42a4.916 4.916 0 0 1-2.61-4.35V7.18c0-2.8 2.28-5.09 5.09-5.09Zm10.43 32.394V14.24H9.64v11.83c0 .9.5 1.73 1.29 2.15l11.74 6.264ZM32 39.47l6.81-3.64.01-.01V14.24H25.19v21.59L32 39.47Zm21.05-11.25c.8-.43 1.29-1.25 1.29-2.15h-.01V7.18a2.59 2.59 0 0 0-2.59-2.59H12.23a2.59 2.59 0 0 0-2.59 2.59v4.56h40.45v2.5H41.3v20.25l11.75-6.27ZM32 42.28l3.27 6.64 7.33 1.06-5.3 5.16 1.25 7.3L32 58.99l-6.55 3.45 1.25-7.3-5.3-5.16 7.33-1.06L32 42.28Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconMilitary = function IconMilitary(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Military' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Military"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconMilitary.sizes = [16, 24, 32, 48, 64];
IconMilitary.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconMilitary;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Military.js
// module id = 1787
// module chunks = 0